/* Keeps lens package lines tied to their frame line (linked by the _lens_set
 * line-item property):
 *  - frame removed            -> its lens line is removed
 *  - frame qty changed        -> lens qty follows the frame qty
 *  - lens line with no frame  -> removed (e.g. added on its own)
 * Runs on the cart page load, after any /cart/change or /cart/update request,
 * and right before checkout (the checkout guard), so checkout never starts
 * with a lens that has no frame or a different quantity. */
(function () {
  'use strict';
  var LENS_HANDLE = 'prescription-lens-package';
  var busy = null; // promise of a running sync
  var origFetch = window.fetch.bind(window);

  // Lens lines can't be changed on their own: hide their quantity + remove controls.
  var css = document.createElement('style');
  css.textContent =
    '.is-lens-line m-cart-remove-button,.is-lens-line .m-quantity__button{display:none!important}' +
    '.is-lens-line .m-quantity{border-color:transparent!important;pointer-events:none}' +
    '.is-lens-line .m-quantity__input{pointer-events:none}' +
    '.lens-line-note{margin:4px 0 6px;font-size:12px;color:#6b6b6b}' +
    '.lens-cart-msg{margin:0 0 12px;padding:10px 14px;border-radius:8px;background:#fff8eb;color:#7a4b00;font-size:14px}';
  (document.head || document.documentElement).appendChild(css);

  function setOf(item) { return item.properties && item.properties._lens_set; }

  // Returns {updates, changed} needed to make lens lines match their frames.
  function plan(cart) {
    var frames = {};
    cart.items.forEach(function (it) {
      var s = setOf(it);
      if (s && it.handle !== LENS_HANDLE) frames[s] = (frames[s] || 0) + it.quantity;
    });
    var updates = {};
    var changed = false;
    cart.items.forEach(function (it) {
      if (it.handle !== LENS_HANDLE) return;
      var s = setOf(it);
      var want = s ? frames[s] || 0 : 0;
      if (it.quantity !== want) { updates[it.key] = want; changed = true; }
    });
    return { updates: updates, changed: changed };
  }

  function sync() {
    if (busy) return busy;
    busy = origFetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var p = plan(cart);
        if (!p.changed) return false;
        return origFetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: p.updates }),
        }).then(function () { return true; });
      })
      .catch(function () { return false; })
      .then(function (changed) { busy = null; return changed; });
    return busy;
  }

  // notice=true when the shopper did not cause the change (page load, checkout);
  // removing a frame themselves needs no explanation.
  function syncAndReload(notice) {
    return sync().then(function (changed) {
      if (changed) {
        if (notice) { try { sessionStorage.setItem('lensCartMsg', '1'); } catch (e) {} }
        window.location.reload();
      }
      return changed;
    });
  }

  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(window, arguments);
    if (/\/cart\/(change|update)/.test(url)) {
      p.then(function () { setTimeout(function () { syncAndReload(false); }, 30); }).catch(function () {});
    }
    return p;
  };

  /* ---------- checkout guard ---------- */
  var approved = false;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('button[name="checkout"], input[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"]');
    if (!btn || approved) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (btn.dataset.lensChecking) return;
    btn.dataset.lensChecking = '1';
    btn.setAttribute('aria-busy', 'true');
    sync().then(function (changed) {
      delete btn.dataset.lensChecking;
      btn.removeAttribute('aria-busy');
      if (changed) {
        // the cart was corrected: show it again before going to checkout
        try { sessionStorage.setItem('lensCartMsg', '1'); } catch (err) {}
        window.location.href = '/cart';
        return;
      }
      approved = true;
      if (btn.tagName === 'A') { window.location.href = btn.href; return; }
      var form = btn.form || (btn.getAttribute('form') && document.getElementById(btn.getAttribute('form')));
      if (form) {
        var hidden = document.createElement('input');
        hidden.type = 'hidden'; hidden.name = 'checkout'; hidden.value = '1';
        form.appendChild(hidden);
        if (form.requestSubmit) form.requestSubmit(); else form.submit();
      } else {
        window.location.href = '/checkout';
      }
    });
  }, true);

  /* ---------- notice after an automatic correction ---------- */
  function showMsg() {
    var flag = null;
    try { flag = sessionStorage.getItem('lensCartMsg'); sessionStorage.removeItem('lensCartMsg'); } catch (e) {}
    if (!flag) return;
    var target = document.querySelector('form[action*="/cart"]') || document.querySelector('main');
    if (!target) return;
    var msg = document.createElement('p');
    msg.className = 'lens-cart-msg';
    msg.setAttribute('role', 'status');
    msg.textContent = 'Your lenses were updated to match the frames in your cart. Please review your cart.';
    target.parentNode.insertBefore(msg, target);
  }

  function onReady(fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }
  onReady(showMsg);
  // On load only on the cart page (covers non-ajax remove links that reload /cart).
  if (/\/cart\/?$/.test(window.location.pathname)) onReady(function () { syncAndReload(true); });
})();
